var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../../../box/Box";
import { Img } from "../../../image";
import Text from "../../../text/Text";
import useResponsiveProp from "../../../hooks/useResponsiveProp";
export function DefaultProductBox(_a) {
    var title = _a.title, titleProps = _a.titleProps, content = _a.content, contentProps = _a.contentProps, imgUrl = _a.imgUrl, altText = _a.altText, href = _a.href, target = _a.target, onClick = _a.onClick, children = _a.children;
    var linkProps = href ? { href: href, target: target, onClick: onClick } : {};
    return (React.createElement(Box, __assign({ display: "block", as: href ? "a" : "div" }, linkProps, { style: { textDecoration: "none" } }),
        React.createElement(Img, { placeholder: [460, 460], src: "".concat(imgUrl), alt: altText }),
        React.createElement(Box, { py: 4 },
            React.createElement(Text, __assign({ as: "p", typeStyle: "title04", mb: 2, dangerouslySetInnerHTML: { __html: title } }, titleProps)),
            content && (React.createElement(Text, __assign({ as: "p", typeStyle: "text04" }, contentProps, { dangerouslySetInnerHTML: { __html: content } }))),
            children)));
}
var gridGapSizeMap = {
    none: 0,
    small: 32,
    medium: 64,
    large: 96,
    xlarge: 128,
};
var ProductGrid = function (_a) {
    var _b = _a.columnCount, columnCount = _b === void 0 ? 3 : _b, _c = _a.gridGapSize, gridGapSize = _c === void 0 ? "none" : _c, children = _a.children, rest = __rest(_a, ["columnCount", "gridGapSize", "children"]);
    var gap = useResponsiveProp([24, 32, 48, gridGapSizeMap[gridGapSize]]);
    var isThree = React.Children.count(children) === 3;
    var columns = useResponsiveProp(isThree ? [1, columnCount] : [1, 2, 2, columnCount]);
    return (React.createElement(Box, __assign({ display: "grid", gridTemplateColumns: "repeat(".concat(columns, ", 1fr)"), gridGap: gap, px: [0, 0, 48, gridGapSizeMap[gridGapSize]] }, rest, { children: children })));
};
export default ProductGrid;
//# sourceMappingURL=ProductGrid.js.map